module.exports = __webpack_public_path__ + "static/img/anli.bc422a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bigHome/anli.png
// module id = KK0+
// module chunks = 0